/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credential_Already_LinkedInputs */

const en_us2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That email is already linked to another account.`)
};

const pt_br2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse e-mail já está vinculado a outra conta.`)
};

const es_419_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese correo ya está vinculado a otra cuenta.`)
};

const pt_pt2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse e-mail já está associado a outra conta.`)
};

const fr_fr2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet e-mail est déjà associé à un autre compte.`)
};

const de_de2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese E-Mail ist bereits mit einem anderen Konto verknüpft.`)
};

const it_it2_credential_already_linked = /** @type {(inputs: Credential_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa email è già collegata a un altro account.`)
};

/**
* | output |
* | --- |
* | "That email is already linked to another account." |
*
* @param {Credential_Already_LinkedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const credential_already_linked = /** @type {((inputs?: Credential_Already_LinkedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credential_Already_LinkedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_credential_already_linked(inputs)
	if (locale === "es-419") return es_419_credential_already_linked(inputs)
	if (locale === "pt-PT") return pt_pt2_credential_already_linked(inputs)
	if (locale === "fr-FR") return fr_fr2_credential_already_linked(inputs)
	if (locale === "de-DE") return de_de2_credential_already_linked(inputs)
	if (locale === "it-IT") return it_it2_credential_already_linked(inputs)
	return en_us2_credential_already_linked(inputs)
});
export { credential_already_linked as "credential.already_linked" }